/**
 * @module endpoint-request
 */
'use strict';

var _classCallCheck = require("/home/jenkins/workspace/Production/website-vostro/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/jenkins/workspace/Production/website-vostro/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/jenkins/workspace/Production/website-vostro/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/jenkins/workspace/Production/website-vostro/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var WPRequest = require('./constructors/wp-request');

var mixins = require('./mixins');

var applyMixin = require('./util/apply-mixin');
/**
 * Create an endpoint request handler constructor for a specific resource tree
 *
 * @method create
 * @param {Object} handlerSpec A resource handler specification object
 * @param {String} resource    The root resource of requests created from the returned factory
 * @param {String} namespace   The namespace string for the returned factory's handlers
 * @returns {Function} A constructor inheriting from {@link WPRequest}
 */


function createEndpointRequest(handlerSpec, resource, namespace) {
  // Create the constructor function for this endpoint
  var EndpointRequest = /*#__PURE__*/function (_WPRequest) {
    _inherits(EndpointRequest, _WPRequest);

    var _super = _createSuper(EndpointRequest);

    function EndpointRequest(options) {
      var _this;

      _classCallCheck(this, EndpointRequest);

      _this = _super.call(this, options);
      /**
       * Semi-private instance property specifying the available URL path options
       * for this endpoint request handler, keyed by ascending whole numbers.
       *
       * @property _levels
       * @type {object}
       * @private
       */

      _this._levels = handlerSpec._levels; // Configure handler for this endpoint's root URL path & set namespace

      _this.setPathPart(0, resource).namespace(namespace);

      return _this;
    }

    return EndpointRequest;
  }(WPRequest); // Mix in all available shortcut methods for GET request query parameters that
  // are valid within this endpoint tree


  if (typeof handlerSpec._getArgs === 'object') {
    Object.keys(handlerSpec._getArgs).forEach(function (supportedQueryParam) {
      var mixinsForParam = mixins[supportedQueryParam]; // Only proceed if there is a mixin available AND the specified mixins will
      // not overwrite any previously-set prototype method

      if (typeof mixinsForParam === 'object') {
        Object.keys(mixinsForParam).forEach(function (methodName) {
          applyMixin(EndpointRequest.prototype, methodName, mixinsForParam[methodName]);
        });
      }
    });
  }

  Object.keys(handlerSpec._setters).forEach(function (setterFnName) {
    // Only assign setter functions if they do not overwrite preexisting methods
    if (!EndpointRequest.prototype[setterFnName]) {
      EndpointRequest.prototype[setterFnName] = handlerSpec._setters[setterFnName];
    }
  });
  return EndpointRequest;
}

module.exports = {
  create: createEndpointRequest
};